export const NEXT_3_DAYS = 'NEXT_3_DAYS'
export const NEXT_5_DAYS = 'NEXT_5_DAYS'
export const THIS_WEEK = 'THIS_WEEK'
export const NEXT_WEEK = 'NEXT_WEEK'
export const SPECIFIC_DATES = 'SPECIFIC_DATES'
export const DEFAULT_TIMEZONE = 'America/New_York'

export const AVAILABILITY_OPTIONS_SEND_VIA_CALENDLY_STEP = {
  [NEXT_3_DAYS]: 'select_next_3_available_dates',
  [NEXT_5_DAYS]: 'select_next_5_available_dates',
  [THIS_WEEK]: 'select_this_week',
  [NEXT_WEEK]: 'select_next_week',
  [SPECIFIC_DATES]: 'select_specific_dates'
}
